export default {
    FREQUENCIA: 'frequencia',
    INTERVALO: 'intervalo',
    TURNO: 'turno',
}